import React from 'react';
// import { Accordion, List } from 'antd-mobile';
import '../../index.css';
import intl from 'react-intl-universal';


class Page2 extends React.Component {
    onChange = (key) => {
        console.log(key);
    }
    render() {
        return (
            // <div style={{ marginTop: 10, marginBottom: 10 }}>
            //     <Accordion defaultActiveKey="0" className="my-accordion" onChange={this.onChange} defaultActiveKey>
            //         <Accordion.Panel header="App注册的时候无法用手机号注册" className="pad">
            //             后来其他backer指导该用户area code只是判断国家，需要用邮箱注册
            //         </Accordion.Panel>
            //         <Accordion.Panel header="app注册提示长度限制为8-20区分大小写" className="pad">
            //             让用户重新使用新密码字母+数字限制为8-20区分大小
            //         </Accordion.Panel>
            //     </Accordion>
            // </div>
            <div className="body_pad">
                {intl.getHTML('a1')}
            </div>
        );
    }
}
export default Page2;